import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, Text, Alert, Modal } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import toastsActionCreators from "~/store/toasts/actions";
import PasswordResetForm from "~/forms/PasswordResetForm";
import passwordResetSchema from "~/forms/PasswordResetForm/passwordResetSchema";
import authActionCreators from "~/store/auth/actions";
import authSelectors from "~/store/auth/selectors";
import PasswordResetCodeForm from "~/forms/PasswordResetCodeForm";
import passwordResetCodeSchema from "~/forms/PasswordResetCodeForm/passwordResetCodeSchema";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const PasswordResetModal = _ref => {
  let {
    email,
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const error = useSelector(authSelectors.getPasswordResetError);
  const status = useSelector(authSelectors.getPasswordResetStatus);
  const [verifyCode, setVerifyCode] = useState(false);
  const dispatch = useDispatch();
  const defaultValues = {
    email: email || "",
    password: "",
    repeatPassword: "",
    code: ""
  };
  const {
    handleSubmit,
    control,
    watch,
    reset
  } = useForm({
    resolver: yupResolver(verifyCode ? passwordResetCodeSchema : passwordResetSchema),
    mode: "onChange",
    defaultValues
  });
  useEffect(() => {
    reset(defaultValues);
    setVerifyCode(false);
  }, [open]);
  const onSubmit = handleSubmit(data => {
    if (verifyCode) {
      dispatch(authActionCreators.resetPasswordCodeStarted(data, _ref2 => {
        let {
          data: isSent
        } = _ref2;
        if (isSent) {
          setVerifyCode(false);
          onClose();
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("PasswordResetModal.passwordChanged"),
            timeout: 10000
          }));
        }
      }));
    } else {
      dispatch(authActionCreators.resetPasswordStarted(data, _ref3 => {
        let {
          data: isSent
        } = _ref3;
        if (isSent) {
          setVerifyCode(true);
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("PasswordResetModal.resetCodeSent", {
              email: data.email
            }),
            timeout: 10000
          }));
        }
      }));
    }
  });
  const handleClose = () => {
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("PasswordResetModal.resetPassword"),
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "420px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    s: {
      mb: 3
    }
  }, t("PasswordResetModal.description")), verifyCode ? /*#__PURE__*/React.createElement(PasswordResetCodeForm, {
    control: control
  }) : /*#__PURE__*/React.createElement(PasswordResetForm, {
    control: control,
    watch: watch
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, verifyCode ? t("PasswordResetModal.verifyCode") : t("PasswordResetModal.sendCode")))));
};
export default PasswordResetModal;